import React, { useState, useEffect } from "react";
import clinic1 from "../../../assets/images/homeopathyjayanagarclinic.jpg";
import clinic2 from "../../../assets/images/hcurahomeopathyclinicinjayanagar.jpg";
import clinic3 from "../../../assets/images/hcurahomeopathydoctorconsultantinjayanagar.jpg";
import clinic4 from "../../../assets/images/hcurahomeopathymedicinejayanagar.jpg";
import "./bangalorejay.css";
import { Link } from "react-router-dom";
import favicon from "./../../../assets/images/favicon.ico"

const JayanagarBranch = () => {
  const benefitsData = {
    "DR.JHOTHI":
      "Our services are accessible to patients worldwide, making quality homeopathic care available to everyone.",
    "DR.SPOORTHI":
      "Online consultations eliminate travel costs and reduce healthcare expenses, making holistic healthcare more affordable.",
    "DR.NILOFER":
      "Easy follow-ups ensure continuity of treatment, improving overall results.",
    "DR.VENA":
      "Consult from the comfort of your home, eliminating the need for travel.",
    "DR.RENUKA Treatment Plan":
      "Every patient receives a tailored treatment plan for their unique needs.",
  };

  const [activeBenefit, setActiveBenefit] = useState("DR.JHOTHI");
  useEffect(() => {
      document.title = "H-Cura Homeopathy Clinic in Jayanagar, Bangalore - Trusted Multispeciality Care";
      const metaDescription = document.querySelector("meta[name='description']");
      if (metaDescription) {
        metaDescription.setAttribute(
          "content",
          "Visit H-Cura Homeopathy Clinic in Jayanagar, Bangalore for expert homeopathic treatments. Our multispeciality clinic offers personalized care for various health conditions with proven remedies. Book your offline consultation today for effective, holistic healing."
        );
      }
      const metaKeywords = document.querySelector("meta[name='keywords']");
      if (metaKeywords) {
        metaKeywords.setAttribute(
          "content",
          "Homeopathy clinic in Jayanagar, Bangalore, Best homeopathy treatment in Bangalore, Skin treatment homeopathy Jayanagar, Cancer treatment homeopathy in Bangalore, Hair fall treatment homeopathy Bangalore, Natural homeopathy healing Jayanagar, Homeopathic remedies for cancer in Bangalore, Skin care homeopathy clinic Jayanagar, Holistic healing homeopathy Bangalore, Top homeopaths in Jayanagar, Homeopathic doctor in Jayanagar, Bangalore, H-Cura Homeopathy Bangalore, Homeopathy for chronic diseases Bangalore, Homeopathy for pain relief in Jayanagar, Homeopathy for skin problems Bangalore, Alternative medicine clinic Jayanagar, Treatment for stress and anxiety homeopathy Bangalore, Personalized homeopathy treatment Bangalore, Best homeopathy treatment for arthritis Bangalore, Weight loss homeopathy Jayanagar."
        );
      }
       // Set canonical link
       const existingCanonical = document.querySelector("link[rel='canonical']");
       if (existingCanonical) {
         existingCanonical.setAttribute("href", "https://www.h-cura.com/homeopathy-clinic-in-jayanagar/");
       } else {
         const canonicalLink = document.createElement("link");
         canonicalLink.setAttribute("rel", "canonical");
         canonicalLink.setAttribute("href", "https://www.h-cura.com/homeopathy-clinic-in-jayanagar/");
         document.head.appendChild(canonicalLink);
       }
       // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
    }, []);

  return (
    // Add this at the beginning of your component's return statement
    <div className="jay-page-layout">
      {/* Left Side Navigation */}
      <div className="jay-branch-nav">
        <h3 className="jay-nav-title">Bangalore Branches</h3>
        <div className="jay-branch-links">
          <Link to="/homeopathy-clinic-in-bangalore/" className="jay-branch-link">
            Bangalore Main
          </Link>
        </div>
      </div>
      {/* 2 */}
      {/* Wrap your existing article in this div */}
      <div className="jay-main-content">
        <article className="jay-branch-container">
          <div className="jay-branch-inner">
            {/* Header */}
            <header className="jay-branch-header">
              <h1 className="jay-branch-heading">
                H-Cura Homeopathy Clinic - Jayanagar Bangalore
              </h1>
              <p className="jay-branch-tagline">
                Your Trusted Destination for Natural Healthcare in Bangalore
              </p>
            </header>
          </div>
          {/* 3 */}
          {/* Content Wrapper */}
          <div className="jay-branch-content">
            {/* Welcome */}
            <section className="jay-welcome-block">
              <h2 className="jay-welcome-heading">
                Welcome to H-Cura Homeopathy Clinic
              </h2>
              <p className="jay-welcome-text">
                Welcome to H-Cura Homeopathy Clinic, your trusted destination
                for natural and holistic healthcare in Bangalore. Located in the
                heart of Jayanagar, our offline clinic is dedicated to providing
                personalized homeopathic treatments for various health concerns.
                Whether it’s managing chronic illnesses, improving skin and hair
                health, or addressing lifestyle-related conditions, we offer
                compassionate care and effective solutions for your well-being.
              </p>
            </section>
            {/* 4 */}
            {/* Features */}
            <section className="jay-why-choose-section">
              <h2>Why Choose Our Bangalore Clinic?</h2>
              <div className="jay-features-list">
                <div className="jay-features-grid">
                  {/* First Row */}
                  <div className="jay-features-row">
                    <div className="jay-feature-item">
                      <div className="jay-feature-icon1" />
                      <h3>Central Location</h3>
                      <p>
                        Our clinic is easily accessible for patients across
                        Bangalore, making it a convenient choice for quality
                        healthcare.
                      </p>
                    </div>
                    <div className="jay-feature-item">
                      <div className="jay-feature-icon1" />
                      <h3>Expert Team</h3>
                      <p>
                        {" "}
                        With a team of skilled practitioners, we bring years of
                        expertise to treat various health issues naturally and
                        effectively
                      </p>
                    </div>
                  </div>

                  {/* Second Row */}
                  <div className="jay-features-row">
                    <div className="jay-feature-item">
                      <div className="jay-feature-icon1" />
                      <h3>Comfortable Offline Clinic</h3>
                      <p>
                        Our Jayanagar clinic offers a welcoming and calming
                        environment, ensuring a stress-free healthcare
                        experience.
                      </p>
                    </div>
                    <div className="jay-feature-item">
                      <div className="jay-feature-icon1" />
                      <h3>Tailored Treatment Plans</h3>
                      <p>
                        {" "}
                        We create customized solutions to address the root
                        causes of your health concerns, focusing on long-term
                        recovery and wellness.
                      </p>
                    </div>
                  </div>
                  <div className="jay-feature-item">
                    <div className="jay-feature-icon1" />
                    <h3>Trusted by Bangalore Families</h3>
                    <p>
                      {" "}
                      Recognized as one of the most reliable homeopathy clinics
                      in Bangalore, we’ve earned the trust of countle
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Treatments */}
            {/* 5 */}
            <section className="jay-treatments-block">
              <h2 className="jay-treatments-headings">
                What We Treat at Our Jayanagar Clinic
              </h2>
              {/* <h2 className="jay-treatments-heading">What We Treat at Our Jayanagar Clinic</h2> <br></br> */}
              <div className="jay-treatments-wrapper">
                <article className="jay-treatment-box">
                  <h3 className="jay-treatment-title">Skin & Hair Care</h3>
                  <ul className="jay-treatment-list">
                    <li className="jay-treatment-item">
                      Acne & Eczema Treatment
                    </li>
                    <li className="jay-treatment-item">Hair Fall Solutions</li>
                    <li className="jay-treatment-item">Psoriasis Management</li>
                    <li className="jay-treatment-item">
                      Pigmentation Treatment
                    </li>
                  </ul>
                </article>
                <article className="jay-treatment-box">
                  <h3 className="jay-treatment-title">Chronic Conditions</h3>
                  <ul className="jay-treatment-list">
                    <li className="jay-treatment-item">Arthritis Management</li>
                    <li className="jay-treatment-item">Thyroid Disorders</li>
                    <li className="jay-treatment-item">Diabetes Care</li>
                    <li className="jay-treatment-item">Autoimmune Diseases</li>
                  </ul>
                </article>
                <article className="jay-treatment-box">
                  <h3 className="jay-treatment-title">Women's Health</h3>
                  <ul className="jay-treatment-list">
                    <li className="jay-treatment-item">PCOS Treatment</li>
                    <li className="jay-treatment-item">Menstrual Problems</li>
                    <li className="jay-treatment-item">Fertility Support</li>
                    <li className="jay-treatment-item">Hormonal Balance</li>
                  </ul>
                </article>
                <article className="jay-treatment-box">
                  <h3 className="jay-treatment-title">Respiratory Health</h3>
                  <ul className="jay-treatment-list">
                    <li className="jay-treatment-item">Bronchitis</li>
                    <li className="jay-treatment-item">sinusitis</li>
                    <li className="jay-treatment-item">chronic Cough</li>
                  </ul>
                </article>
                <article className="jay-treatment-box">
                  <h3 className="jay-treatment-title">Mental Health Support</h3>
                  <ul className="jay-treatment-list">
                    <li className="jay-treatment-item">
                      Holistic Care for Anxiety
                    </li>
                    <li className="jay-treatment-item">Depression</li>
                    <li className="jay-treatment-item">Stress</li>
                    <li className="jay-treatment-item">Insomnia</li>
                  </ul>
                </article>
              </div>
            </section>
            {/* </section> */}
            {/* 6 */}
            {/* Doctors */}
            <section className="jay-doctors-section">
              <div className="benefits2">
                <h2>Expert Doctors at Our Bangalore Clinics</h2>
                <div className="benefitpoints2">
                  {Object.keys(benefitsData).map((benefit) => (
                    <h3
                      key={benefit}
                      onClick={() => setActiveBenefit(benefit)}
                      className={activeBenefit === benefit ? "active" : ""}
                    >
                      {benefit}
                    </h3>
                  ))}
                </div>

                {activeBenefit && (
                  <p className="benefit-description2">
                    {benefitsData[activeBenefit]}
                  </p>
                )}
              </div>
            </section>
            {/* 7 */}
            <div className="bng-clinic-slider">
              <div className="bng-slider-wrapper">
                {[clinic1, clinic2, clinic3, clinic4].map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={"Clinic View ${index + 1}"}
                    className="bng-slider-image"
                  />
                ))}
              </div>
            </div>
            {/* 8 */}
            <section className="jayanagar-map-contact">
              <div className="jayanagar-map-container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.855518904106!2d77.59318457341338!3d12.917006187393337!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14d8dd315555%3A0x837b338b42d71825!2sH-Cura%20Homeopathy%20Clinic%2C%20Jayanagar%2C%20Bangalore!5e0!3m2!1sen!2sin!4v1734589397892!5m2!1sen!2sin"
                  className="jayanagar-google-map"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              <div className="jayanagar-address-info">
                <div className="jayanagar-address-card">
                  <h3>H-Cura Homeopathy Clinic</h3>
                  <div className="jayanagar-address-content">
                    <div className="jayanagar-contact-details">
                      <p>30th Cross, Near Jain Temple</p>
                      <p>4th Block, Jayanagar</p>
                      <p>Bangalore - 560041</p>
                      <p>Karnataka, India</p>
                    </div>
                    <div className="jayanagar-contact-timing">
                      <p>
                        <strong>Hours:</strong> Mon-Sat: 9:00 AM - 8:00 PM
                      </p>
                      <p>
                        <strong>Phone:</strong> +91 98765 43210
                      </p>
                      <p>
                        <strong>Email:</strong> info@hcuraclinic.com
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* 9 */}
            {/* Why We're the Best Section */}
            <div className="jay-best-section">
              <h2 className="jay-best-heading">
                Why We're the Best Homeopathy Clinic in Bangalore
              </h2>
              <div className="jay-best-content">
                <p className="jay-best-description">
                  At H-Cura Homeopathy, we combine science, empathy, and natural
                  remedies to deliver exceptional healthcare. Our Jayanagar
                  clinic is known for its patient-first approach, making it one
                  of the most trusted offline homeopathy clinics in Bangalore.
                </p>
              </div>
            </div>
            {/* 10 */}
            {/* Contact */}

            <div className="jay-cta-section">
              <h2 className="jay-cta-title">Book Your Appointment Today</h2>
              <p className="jay-cta-text">
                Discover the power of homeopathy at H-Cura Homeopathy’s
                Jayanagar clinic. Our friendly team is here to guide you toward
                better health. Book your appointment now and experience holistic
                healing in a comfortable, offline setting.
              </p>
              <br></br>
              <Link to="/bookconsultation" className="jay-cta-button">
                Schedule Consultation
              </Link>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default JayanagarBranch;